<template>
  <div id="nav">
    <router-view />
  </div>
</template>

<script setup>
import { useIdleTimeout } from '@/composables/auth/useIdleTimeout';

useIdleTimeout()
</script>

<style lang="scss">
body {
  margin: 0;
}

.bi {
  line-height: 0;
}
</style>
